<template>
  <v-app id="horizontale-jaloezien-page">
    <Menu />
    <v-container id="horizontale-jaloezien" grid-list-lg>
  
        <v-layout row wrap>
          <!-- Horizontale Jaloezien Block -->
          <v-flex xs12>
            <v-form ref="phaseOne" @submit.prevent="goToPhaseTwo">
              <v-card class="card-expansion">
                <v-toolbar @click="phaseOne" class='elevation-0'
                  :class="stepOne + stepOneActive ? 'panel-open' : 'product-panel'">
                  <img
                    :src="stepOne + stepOneActive ? require('../assets/ui-elements/step1-active.png') : require('../assets/ui-elements/step1.png')"
                    alt="">
                  <v-card-title dark> <span
                      :class="stepOne + stepOneActive ? 'step-tile-active' : 'step-title'">Materiaal</span>
                  </v-card-title>
                  <v-spacer></v-spacer>
                  <h4 class="mr-5 activeProductTitle">{{horizontalblinds | formatHorizontalBlinds}}</h4>
                  <v-icon :class="stepOne + stepOneActive ? 'step-icon-active' : ''">{{toggleIcon(stepOne)}}
                  </v-icon>
                </v-toolbar>
                <transition name="expand">
                  <v-card-text v-if="stepOne">
                    <v-container grid-list-xs>
                      <v-layout row wrap>
                        <v-flex text-xs-center xs12 sm4 md4>
                          <label @click="houtOptions" class="radio-container">
                            <input @click="inputChecked" v-model="horizontalblinds" type="radio" name="bamboe"
                              value="bamboe" required checked="checked">
                            <img :class="horizontalblinds == 'bamboe' ? 'selected' : '' "
                              class="horizontalblinds-product-image" src="../assets/horizontalejaloezien/bamboo.jpg" alt="">
                            <span class="checkmark"></span>
                          </label>
                          <h4 class="mt-2 product-tile-title">Bamboe</h4>
                        </v-flex>
                        <v-flex text-xs-center xs12 sm4>

                          <label @click="aluminiumOptions" class="radio-container">
                            <input @click="inputChecked" v-model="horizontalblinds" type="radio" name="Aluminium"
                              value="aluminium" required>
                            <img :class="horizontalblinds == 'aluminium' ? 'selected' : '' "
                              class="horizontalblinds-product-image" src="../assets/horizontalejaloezien/aluminium.jpg"
                              alt="">
                            <span class="checkmark"></span>
                          </label>

                          <h4 class="mt-2 product-tile-title">Aluminium</h4>
                        </v-flex>
                        <v-flex v-if="error" xs12>
                          <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                        </v-flex>
                        <v-flex v-if="aluminiumBlock" xs12>
                          <span class="options-title">Breedte:</span>
                          <v-radio-group :rules="aluminiumBlockRules" v-model="aluminium">
                            <v-radio label="16 mm" value="16"></v-radio>
                            <v-radio label="25 mm" value="25"></v-radio>
                            <v-radio label="50 mm" value="50"></v-radio>
                          </v-radio-group>
                        </v-flex>
                        <v-flex v-if="houtBlock" xs12>
                          <span class="options-title">Breedte:</span>
                          <v-radio-group :rules="houtBlockRules" v-model="hout">
                            <v-radio label="50 mm" value="50"></v-radio>
                            <v-radio label="65 mm" value="65"></v-radio>
                          </v-radio-group>
                        </v-flex>
                        <v-flex xs12 text-xs-right>
                          <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                            stap <v-icon right>fal fa-chevron-right</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </transition>
              </v-card>
            </v-form>
          </v-flex>

          <!-- Afmetingen Bamboe Block -->
          <v-flex xs12 v-if="houtBlock && !aluminiumBlock">
            <v-form ref="sizesBlock" @submit.prevent="goToPhaseThree">
              <v-card class="card-expansion" :disabled="true">
                <v-toolbar @click="phaseTwo" class='elevation-0'
                  :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                  <img
                    :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                    alt="">
                  <v-card-title dark> <span class="sub-title"
                      :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                  </v-card-title>
                  <v-spacer></v-spacer>
                  <h4 class="mr-5 text-truncate activeProductTitle">B {{bamboeWidth}} x H {{bamboeHeight}} mm</h4>
                  <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                  </v-icon>
                </v-toolbar>
                <transition name="expand">
                  <v-card-text v-if="stepTwo">
                    <v-container grid-list-xs>
                      <v-layout row wrap>

                             <!-- Breedte -->
                        <v-flex xs12 sm4 md3>
                          <v-layout id="height-help" row wrap>
                            <v-flex xs12 sm12 md12 lg12>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="height" xs12 sm7 md8>
                          <v-slider @input="sliderInput" v-model="bamboeWidth"  :max="bamboeMaxWidth"></v-slider>
                          <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                          <v-flex class="max" xs6 text-xs-right>Max {{bamboeMaxWidth}} mm</v-flex>
                        </v-flex>

                        <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                          <span class="info-height mr-2">Breedte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="bamboeWidth" type="number"></v-text-field>
                          </div> <span class="ml-2 info-height">mm</span>
                        </v-flex>

                        <!-- Hoogte -->
                        <v-flex xs12 sm4 md3>
                          <v-layout id="height-help" row wrap>
                            <v-flex xs5 sm4 md5 lg3>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                            </v-flex>
                            <v-flex xs1 sm7 md2 lg3 text-xs-left>
                              <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="height" xs12 sm7 md8>
                          <v-slider @input="sliderInput" v-model="bamboeHeight" :max="bamboeMaxHeight"></v-slider>
                          <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                          <v-flex class="max" xs6 text-xs-right>Max {{bamboeMaxHeight}} mm</v-flex>
                        </v-flex>

                        <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                          <span class="info-height mr-2">Hoogte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="bamboeHeight" type="number"></v-text-field>
                          </div> <span class="ml-2 info-height">mm</span>
                        </v-flex>

                   
                        <v-flex v-if="errorSize" xs12>
                          <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                        </v-flex>
                        <v-flex xs12 text-xs-right>
                          <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                            stap <v-icon right>fal fa-chevron-right</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </transition>
              </v-card>
            </v-form>
          </v-flex>

          <!-- Aluminium 16mm Block -->
           <v-flex xs12 v-if="aluminium == '16' && !houtBlock">
            <v-form ref="sizesBlock" @submit.prevent="goToPhaseThree">
              <v-card class="card-expansion" :disabled="true">
                <v-toolbar @click="phaseTwo" class='elevation-0'
                  :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                  <img
                    :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                    alt="">
                  <v-card-title dark> <span class="sub-title"
                      :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                  </v-card-title>
                  <v-spacer></v-spacer>
                  <h4 class="mr-5 text-truncate activeProductTitle">B {{aluminium16Width}} x H {{aluminium16Height}} mm</h4>
                  <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                  </v-icon>
                </v-toolbar>
                <transition name="expand">
                  <v-card-text v-if="stepTwo">
                    <v-container grid-list-xs>
                      <v-layout row wrap>
                     

                             <!-- Breedte -->
                        <v-flex xs12 sm4 md3>
                          <v-layout id="height-help" row wrap>
                            <v-flex xs12 sm12 md12 lg12>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="height" xs12 sm7 md8>
                          <v-slider @input="sliderInput" v-model="aluminium16Width" :max="aluminium16MaxWidth"></v-slider>
                          <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                          <v-flex class="max" xs6 text-xs-right>Max {{aluminium16MaxWidth}} mm</v-flex>
                        </v-flex>

                        <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                          <span class="info-height mr-2">Breedte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="aluminium16Width" type="number"></v-text-field>
                          </div> <span class="ml-2 info-height">mm</span>
                        </v-flex>

                        <!-- Hoogte -->
                        <v-flex xs12 sm4 md3>
                          <v-layout id="height-help" row wrap>
                            <v-flex xs5 sm4 md5 lg3>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                            </v-flex>
                            <v-flex xs1 sm7 md2 lg3 text-xs-left>
                              <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="height" xs12 sm7 md8>
                          <v-slider @input="sliderInput" v-model="aluminium16Height" :max="aluminium16MaxHeight"></v-slider>
                          <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                          <v-flex class="max" xs6 text-xs-right>Max {{aluminium16MaxHeight}} mm</v-flex>
                        </v-flex>

                        <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                          <span class="info-height mr-2">Hoogte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="aluminium16Height" type="number"></v-text-field>
                          </div> <span class="ml-2 info-height">mm</span>
                        </v-flex>

                   
                        <v-flex v-if="errorSize" xs12>
                          <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                        </v-flex>
                        <v-flex xs12 text-xs-right>
                          <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                            stap <v-icon right>fal fa-chevron-right</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </transition>
              </v-card>
            </v-form>
          </v-flex>

          <!-- Aluminium 25mm  -->
           <v-flex xs12 v-if="aluminium == '25' && !houtBlock">
            <v-form ref="sizesBlock" @submit.prevent="goToPhaseThree">
              <v-card class="card-expansion" :disabled="true">
                <v-toolbar @click="phaseTwo" class='elevation-0'
                  :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                  <img
                    :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                    alt="">
                  <v-card-title dark> <span class="sub-title"
                      :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                  </v-card-title>
                  <v-spacer></v-spacer>
                  <h4 class="mr-5 text-truncate activeProductTitle">B {{aluminium25Width}} x H {{aluminium25Height}} mm</h4>
                  <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                  </v-icon>
                </v-toolbar>
                <transition name="expand">
                  <v-card-text v-if="stepTwo">
                    <v-container grid-list-xs>
                      <v-layout row wrap>
                   

                             <!-- Breedte -->
                        <v-flex xs12 sm4 md3>
                          <v-layout id="height-help" row wrap>
                            <v-flex xs12 sm12 md12 lg12>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="height" xs12 sm7 md8>
                          <v-slider @input="sliderInput" v-model="aluminium25Width" :max="aluminium25MaxWidth"></v-slider>
                          <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                          <v-flex class="max" xs6 text-xs-right>Max {{aluminium25MaxWidth}} mm</v-flex>
                        </v-flex>

                        <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                          <span class="info-height mr-2">Breedte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="aluminium25Width" type="number"></v-text-field>
                          </div> <span class="ml-2 info-height">mm</span>
                        </v-flex>

                        <!-- Hoogte -->
                        <v-flex xs12 sm4 md3>
                          <v-layout id="height-help" row wrap>
                            <v-flex xs5 sm4 md5 lg3>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                            </v-flex>
                            <v-flex xs1 sm7 md2 lg3 text-xs-left>
                              <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="height" xs12 sm7 md8>
                          <v-slider @input="sliderInput" v-model="aluminium25Height" :max="aluminium25MaxHeight"></v-slider>
                          <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                          <v-flex class="max" xs6 text-xs-right>Max {{aluminium25MaxHeight}} mm</v-flex>
                        </v-flex>

                        <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                          <span class="info-height mr-2">Hoogte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="aluminium25Height" type="number"></v-text-field>
                          </div> <span class="ml-2 info-height">mm</span>
                        </v-flex>

                   
                        <v-flex v-if="errorSize" xs12>
                          <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                        </v-flex>
                        <v-flex xs12 text-xs-right>
                          <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                            stap <v-icon right>fal fa-chevron-right</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </transition>
              </v-card>
            </v-form>
          </v-flex>


           <!-- Aluminium 50m  -->
           <v-flex xs12 v-if="aluminium == '50' && !houtBlock">
            <v-form ref="sizesBlock" @submit.prevent="goToPhaseThree">
              <v-card class="card-expansion" :disabled="true">
                <v-toolbar @click="phaseTwo" class='elevation-0'
                  :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                  <img
                    :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                    alt="">
                  <v-card-title dark> <span class="sub-title"
                      :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                  </v-card-title>
                  <v-spacer></v-spacer>
                  <h4 class="mr-5 text-truncate activeProductTitle">B {{aluminium50Width}} x H {{aluminium50Height}} mm</h4>
                  <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                  </v-icon>
                </v-toolbar>
                <transition name="expand">
                  <v-card-text v-if="stepTwo">
                    <v-container grid-list-xs>
                      <v-layout row wrap>
                  

                             <!-- Breedte -->
                        <v-flex xs12 sm4 md3>
                          <v-layout id="height-help" row wrap>
                            <v-flex xs12 sm12 md12 lg12>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="height" xs12 sm7 md8>
                          <v-slider @input="sliderInput" v-model="aluminium50Width" :max="aluminium50MaxWidth"></v-slider>
                          <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                          <v-flex class="max" xs6 text-xs-right>Max {{aluminium50MaxWidth}} mm</v-flex>
                        </v-flex>

                        <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                          <span class="info-height mr-2">Breedte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="aluminium50Width" type="number"></v-text-field>
                          </div> <span class="ml-2 info-height">mm</span>
                        </v-flex>

                        <!-- Hoogte -->
                        <v-flex xs12 sm4 md3>
                          <v-layout id="height-help" row wrap>
                            <v-flex xs5 sm4 md5 lg3>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                            </v-flex>
                            <v-flex xs1 sm7 md2 lg3 text-xs-left>
                              <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="height" xs12 sm7 md8>
                          <v-slider @input="sliderInput" v-model="aluminium50Height" :max="aluminium50MaxHeight"></v-slider>
                          <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                          <v-flex class="max" xs6 text-xs-right>Max {{aluminium50MaxHeight}} mm</v-flex>
                        </v-flex>

                        <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                          <span class="info-height mr-2">Hoogte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="aluminium50Height" type="number"></v-text-field>
                          </div> <span class="ml-2 info-height">mm</span>
                        </v-flex>

                   
                        <v-flex v-if="errorSize" xs12>
                          <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                        </v-flex>
                        <v-flex xs12 text-xs-right>
                          <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                            stap <v-icon right>fal fa-chevron-right</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </transition>
              </v-card>
            </v-form>
          </v-flex>


          <!-- Band Block -->
          <v-flex xs12 v-if="stepThreeOption">
            <v-form ref="band" @submit.prevent="goToPhaseFour">
              <v-card class="card-expansion">
                <v-toolbar @click="phaseThree" class='elevation-0'
                  :class="stepThree + stepThreeActive ? 'panel-open' : 'product-panel'">
                  <img
                    :src="stepThree + stepThreeActive ? require('../assets/ui-elements/step3-active.png') : require('../assets/ui-elements/step3.png')"
                    alt="">
                  <v-card-title dark> <span
                      :class="stepThree + stepThreeActive ? 'step-tile-active' : 'step-title'">Band</span>
                  </v-card-title>
                  <v-spacer></v-spacer>
                  <h4 class="mr-5  activeProductTitle">{{band | formatBand}}</h4>
                  <v-icon :class="stepThree + stepThreeActive ? 'step-icon-active' : ''">{{toggleIcon(stepThree)}}
                  </v-icon>
                </v-toolbar>
                <transition name="expand">
                  <v-card-text v-if="stepThree">
                    <v-container grid-list-xs>
                      <v-layout row wrap>
     <v-flex text-xs-center xs12 sm4 md4>
                          <div class="sub-product-tile" :class="band == 'ladderkoord' ? 'plooi-selected' : '' ">
                            <label class="radio-container">
                              <input @click="inputChecked" v-model="band" type="radio" name="Ladderkoord"
                                value="ladderkoord" required checked>
                              <img class="plooi-product-image pt-3" src="../assets/horizontalejaloezien/ladderkoord.png"
                                alt="">
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <h4 class="mt-2 subproduct-tile-title">Ladderkoord</h4>
                        </v-flex>
    <v-flex text-xs-center xs12 sm4 md4>
                          <div class="sub-product-tile" :class="band == 'breedband' ? 'plooi-selected' : '' ">
                            <label class="radio-container">
                              <input @click="inputChecked" v-model="band" type="radio" name="Breedband"
                                value="breedband" required>
                              <img class="plooi-product-image pt-3" src="../assets/horizontalejaloezien/breedband.png"
                                alt="">
                              <span class="checkmark"></span>
                            </label>

                          </div>
                          <h4 class="mt-2 subproduct-tile-title">Breedband</h4>
                        </v-flex>
                    

                   

                        <v-flex v-if="error" xs12>
                          <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                        </v-flex>

                        <v-flex xs12 text-xs-right>
                          <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                            stap <v-icon right>fal fa-chevron-right</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </transition>
              </v-card>
            </v-form>
          </v-flex>

          <!-- Totaal Block -->
          <v-flex xs12>
                <v-form @submit.prevent="submitForm" ref="horizontalblindsForm">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseFour" class='elevation-0'
                :class="stepFour ? 'panel-open' : 'product-panel'">
                <img v-if="stepThreeOption"
                  :src="stepFour   ? require('../assets/ui-elements/step4-active.png') : require('../assets/ui-elements/step4.png')"
                  alt="">
                   <img v-if="!stepThreeOption"
                  :src="stepFour   ? require('../assets/ui-elements/step3-active.png') : require('../assets/ui-elements/step3.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepFour ? 'step-tile-active' : 'step-title'">Totaal</span>
                </v-card-title>
                <v-spacer></v-spacer>
 <h4 class="mr-5 text-truncate activeProductTitle">&#8364; {{totalPrice | currency}}</h4>
                <v-icon :class="stepFour ? 'step-icon-active' : ''">{{toggleIcon(stepFour)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepFour">
                  <v-container grid-list-xs>
                    <v-layout row wrap>

                      <!-- Type stof -->
                      <v-flex xs4 sm2 md2><span class="total-title">Materiaal:</span></v-flex>
                      <v-flex xs8 sm10 md10><span class="total-item">{{horizontalblinds | formatHorizontalBlinds}}</span>
                      </v-flex>

                          <v-flex xs4 sm2 md2><span class="total-title">Stofbreedte:</span></v-flex>
                      <v-flex xs8 sm10 md10>
                        <span v-if="houtBlock" class="total-item">{{hout}}mm</span>
                        <span v-if="aluminiumBlock" class="total-item">{{aluminium}}mm</span>
                      </v-flex>

                      <!-- Afmetingen -->
                      <v-flex xs4 sm2 md2><span class="total-title">Afmeting:</span></v-flex>
                      <v-flex xs8 sm10 md10><span v-if="hout != '' && !aluminiumBlock" class="total-item">Breedte {{bamboeWidth}} mm x Hoogte
                          {{bamboeHeight}} mm </span>
                        
                          <span class="total-item" v-if="aluminium == '16' && !houtBlock">Breedte {{aluminium16Width}} mm x Hoogte
                          {{aluminium16Height}} mm</span>

                            <span class="total-item" v-if="aluminium == '25' && !houtBlock">Breedte {{aluminium25Width}} mm x Hoogte
                          {{aluminium25Height}} mm</span>

                            <span class="total-item" v-if="aluminium == '50' && !houtBlock">Breedte {{aluminium50Width}} mm x Hoogte
                          {{aluminium50Height}} mm</span>
                          </v-flex>

                      <!-- Band -->
                      <v-flex xs4 sm2 md2 v-if="houtBlock"><span class="total-title">Band:</span></v-flex>
                      <v-flex xs8 sm10 md10 v-if="houtBlock"> <span class="total-item">
                          {{band | formatBand}}</span></v-flex>

                      <!-- Ruimte/Raam + Totale Prijs & Button -->
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4 sm2 md2><span class="total-title">Aantal</span></v-flex>
                          <v-flex xs6 sm10 md10>
                            <v-text-field class="quantity-input" :rules="quantityRules" v-model="quantity" type="number"
                              outline></v-text-field>
                          </v-flex>
                          <v-flex xs4 sm2 md2>
                            <span class="total-title">Ruimte / raam</span>
                          </v-flex>
                          <v-flex xs8 sm8 md8>
                            <v-text-field class='price-input' v-model="room" type="text" outline
                              label="Typ hier een naam voor de ruimte of het raam">
                            </v-text-field>
                          </v-flex>
                          <v-flex text-xs-center xs12>
                            <hr class="seperator-line">
                          </v-flex>
                          <v-flex xs2 text-xs-left>
                            <span class="end-total-title">Totaal</span>
                          </v-flex>
                          <v-flex xs10 text-xs-right>
                            <h2 class="price-total"> <span class="price-title mr-3">Prijs compleet,
                                incl. BTW </span> €
                              {{totalPrice | currency}}</h2>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
            <v-flex id="col-btn" xs12 text-xs-right>
              <v-btn type="submit" color="primary" depressed class="text-none form-btn">Plaats op lijst
                <v-icon class="icon-size" right>fal fa-plus</v-icon>
              </v-btn>
            </v-flex>
                </v-form>
          </v-flex>
        </v-layout>
 
    </v-container>
    <SnackBar v-model="snackbar" :text="messageTxt" :color="color" />
  </v-app>
</template>


<script>
import Menu from '@/components/Menu';
import Messages from '@/services/messages.service'; // Meldingen
import SnackBar from '@/components/SnackBar';
import ApiService from '@/services/api.service'; // Api
import FormatService from '@/services/format.service';

export default {
  components: {
    Menu,
    SnackBar
  },
  data() {
    return {
      active: false,
      stepOne: false,
      stepTwo: false,
      stepThree: false,
      stepFour: false,
      stepOneActive: false,
      stepTwoActive: false,
      stepThreeActive: false,
      stepThreeOption: true,
      height: 0,
      width: 0,
      min: 250,
      max: 10000,
      bamboeWidth: null,
      bamboeHeight: null,
      bamboeMaxWidth: 2500,
      bamboeMaxHeight: 3600,
      aluminium16MaxWidth: 2000,
      aluminium16MaxHeight: 2200,
      aluminium16Width: null,
      aluminium16Height: null,
      aluminium25MaxWidth: 2500,
      aluminium25MaxHeight: 2200,
      aluminium25Width: null,
      aluminium25Height: null,
      aluminium50MaxWidth: 4000,
      aluminium50MaxHeight: 4000,
      aluminium50Width: null,
      aluminium50Height: null,
      horizontalblinds: 'bamboe',
      band: 'ladderkoord',
      hout: '50',
      aluminium: '16',
      price: 0,
      productPrijs: 0,
      quantity: 1,
      room: '',
      aluminiumBlock: false,
      aluminiumBlockRules: [aluminium => !!aluminium || Messages.ChoiceValidationMessage],
      houtBlockRules: [hout => !!hout || Messages.ChoiceValidationMessage],
      quantityRules: [quantity => !!quantity || Messages.QuantityValidationMessage],
      houtBlock: true,
      error: false,
      errorSize: false,
      errorMsg: '',
      snackbar: false,
      color: '',
      messageTxt: '',
    }
  },
  computed: {
    totalPrice() {
      return this.quantity * this.productPrijs
    },

  },
  methods: {
    getAluminium16Price() {
      if (this.aluminium16Width > 249 && this.aluminium16Height > 249) {
        ApiService.getHorizontalBlindsPrice({
          materiaaltype: this.horizontalblinds,
          materiaalbreedte: this.aluminium,
          hoogte: this.aluminium16Height,
          breedte: this.aluminium16Width
        }).then(response => {
          this.productPrijs = response
        })
      }
    },
    getAluminium25Price() {
      if(this.aluminium25Width > 249 && this.aluminium25Height > 249){
        ApiService.getHorizontalBlindsPrice({
        materiaaltype: this.horizontalblinds,
        materiaalbreedte: this.aluminium,
        hoogte: this.aluminium25Height,
        breedte: this.aluminium25Width
      }).then(response => {
        this.productPrijs = response
      })
      }
    },
    getAluminium50Price() {
     if(this.aluminium50Width > 249 && this.aluminium50Height > 249){
        ApiService.getHorizontalBlindsPrice({
        materiaaltype: this.horizontalblinds,
        materiaalbreedte: this.aluminium,
        hoogte: this.aluminium50Height,
        breedte: this.aluminium50Width
      }).then(response => {
        this.productPrijs = response
      })
     }
    },
    getBamboePrice() {
      if (this.band != 0 && this.bamboeWidth > 249 && this.bamboeHeight > 249) {
        ApiService.getHorizontalBlindsPrice({
          materiaaltype: this.horizontalblinds,
          materiaalbreedte: this.hout,
          bandtype: this.band,
          hoogte: this.bamboeHeight,
          breedte: this.bamboeWidth
        }).then(response => {
          this.productPrijs = response
        })
      }
    },
    phaseOne() {
      this.stepOne = !this.stepOne;
    },
    phaseTwo() {
      this.stepTwo = !this.stepTwo;
    },
    phaseThree() {
      this.stepThree = !this.stepThree;
    },
    phaseFour() {
      this.stepFour = !this.stepFour;
    },
    goToPhaseTwo(e) {
      if (e.target.elements.bamboe.validity.valid ||
        e.target.elements.Aluminium.validity.valid) {
        this.$nextTick(() => {
          if (this.$refs.phaseOne.validate()) {
            this.stepOne = false;
            this.stepTwo = true;
            this.stepOneActive = true;
          }
          if (this.houtBlock && !this.aluminiumBlock) {
            this.getBamboePrice()
          }
          if (this.aluminiumBlock && !this.houtBlock) {
            this.getAluminium16Price()
            this.getAluminium25Price()
            this.getAluminium50Price()
          }
        })
      } else {
        this.$refs.phaseOne.validate()
        this.error = true;
        this.errorMsg = Messages.MaterialValidationMessage;
      }
    },
    goToPhaseThree() {
      if (this.bamboeWidth > 249 && this.bamboeHeight > 249 && !this.aluminiumBlock) {
        this.stepTwo = false;
        this.stepThree = true;
        this.stepTwoActive = true;
        this.getBamboePrice()

      } else {
           this.errorSize = true;
          this.errorMsg = Messages.SizesValidationMessage;
      }

      if (this.aluminium16Width > 249 && this.aluminium16Height > 249) {
        this.stepTwo = false;
        this.stepFour = true;
        this.stepTwoActive = true;
        this.getAluminium16Price()
      }  else {
           this.errorSize = true;
          this.errorMsg = Messages.SizesValidationMessage;
      }

       if (this.aluminium25Width > 249 && this.aluminium25Height > 249) {
        this.stepTwo = false;
        this.stepFour = true;
        this.stepTwoActive = true;
        this.getAluminium25Price()
      }  else {
           this.errorSize = true;
          this.errorMsg = Messages.SizesValidationMessage;
      }
       
       if (this.aluminium50Width > 249 && this.aluminium50Height > 249) {
        this.stepTwo = false;
        this.stepFour = true;
        this.stepTwoActive = true;
        this.getAluminium50Price()
      }  else {
           this.errorSize = true;
          this.errorMsg = Messages.SizesValidationMessage;
      }
    },
    goToPhaseFour(e) {
      if (e.target.elements.Breedband.validity.valid ||
        e.target.elements.Ladderkoord.validity.valid) {
        this.stepOne = false;
        this.stepTwo = false;
        this.stepThree = false;
        this.stepFour = true;
        this.stepThreeActive = true;
        this.getBamboePrice()
      } else {
        this.errorSize = true;
        this.errorMsg = Messages.ChoiceValidationMessage;
      }
    },
    submitForm() {

      if (this.aluminiumBlock) {
        if (this.aluminium == '16') {
          if (this.$refs.horizontalblindsForm.validate()) {
            this.getAluminium16Price()
            this.stepFour = false;
            this.stepOneActive = false;
            this.stepTwoActive = false;
            this.stepThreeActive = false;
            this.snackbar = true;
            this.color = '#006fb3';
            this.messageTxt = Messages.ProductAddedMessage;
            this.$refs.horizontalblindsForm.validate()
            this.$store.dispatch('products/addProduct', {
              naam: this.$router.history.current.name,
              product: this.horizontalblinds,
              stofbreedte: this.aluminium,
              breedte: this.aluminium16Width,
              hoogte: this.aluminium16Height,
              hoeveelheid: this.quantity,
              ruimte: this.room,
              totaleprijs: this.quantity * this.productPrijs
            })
          }
        }
        if (this.aluminium == '25') {
          if (this.$refs.horizontalblindsForm.validate()) {
            this.getAluminium25Price()
            this.stepFour = false;
            this.stepOneActive = false;
            this.stepTwoActive = false;
            this.stepThreeActive = false;
            this.snackbar = true;
            this.color = '#006fb3';
            this.messageTxt = Messages.ProductAddedMessage;
            this.$refs.horizontalblindsForm.validate()
            this.$store.dispatch('products/addProduct', {
              naam: this.$router.history.current.name,
              product: this.horizontalblinds,
              stofbreedte: this.aluminium,
              breedte: this.aluminium25Width,
              hoogte: this.aluminium25Height,
              hoeveelheid: this.quantity,
              ruimte: this.room,
              totaleprijs: this.quantity * this.productPrijs
            })
          }
        }
        if (this.aluminium == '50') {
          if (this.$refs.horizontalblindsForm.validate()) {
            this.getAluminium50Price()
            this.stepFour = false;
            this.stepOneActive = false;
            this.stepTwoActive = false;
            this.stepThreeActive = false;
            this.snackbar = true;
            this.color = '#006fb3';
            this.messageTxt = Messages.ProductAddedMessage;
            this.$refs.horizontalblindsForm.validate()
            this.$store.dispatch('products/addProduct', {
              naam: this.$router.history.current.name,
              product: this.horizontalblinds,
              stofbreedte: this.aluminium,
              breedte: this.aluminium50Width,
              hoogte: this.aluminium50Height,
              hoeveelheid: this.quantity,
              ruimte: this.room,
              totaleprijs: this.quantity * this.productPrijs
            })
          }
        }
      }
      if (this.houtBlock) {
        this.getBamboePrice()
        this.stepFour = false;
        this.stepOneActive = false;
        this.stepTwoActive = false;
        this.stepThreeActive = false;
        this.snackbar = true;
        this.color = '#006fb3';
        this.messageTxt = Messages.ProductAddedMessage;
        this.$refs.horizontalblindsForm.validate()
        this.$store.dispatch('products/addProduct', {
          naam: this.$router.history.current.name,
          product: this.horizontalblinds,
          stofbreedte: this.hout,
          breedte: this.bamboeWidth,
          hoogte: this.bamboeHeight,
          bandtype: this.band,
          hoeveelheid: this.quantity,
          ruimte: this.room,
          totaleprijs: this.quantity * this.productPrijs
        })
      }
    },
    inputChecked(e) {
      if (e.target.validity.valid) {
        this.error = false;
      }

      if (e.target.value == 'bamboe') {
        this.stepThreeOption = true
      }

      if (e.target.value == 'aluminium') {
        this.stepThreeOption = false
      }
    },
    sliderInput(value) {
      if (value > 249) {
        this.errorSize = false;

      }
    },
    toggleIcon(value) {
      if (value) {
        return 'fal fa-minus-circle';
      } else {
        return 'fal fa-plus-circle';
      }
    },
    aluminiumOptions() {
      this.aluminiumBlock = true;
      this.houtBlock = false;
    },
    houtOptions() {
      this.aluminiumBlock = false;
      this.houtBlock = true;
    }
  },
  filters: {
    ...FormatService
  }
}
</script>

<style scoped>
#horizontale-jaloezien-page {
  background-color: #fff;
}


.card-expansion {
  box-shadow: none;
  border: 1px solid #eaeaea;
}

.min {
  padding: 0 !important;
  margin: 0 !important;
  position: relative;
  top: 0;
  left: 0;
  left: -5%;
  top: -15%;
  color: #b4b4b4;
  font-size: 12px;
  font-weight: 400;
}

.max {
  padding: 0 !important;
  margin: 0 !important;
  position: relative;
  clear: both;
  right: -55%;
  top: -34%;
  color: #b4b4b4;
  font-size: 12px;
  font-weight: 400;
}

.options-title {
  font-size: 15px;
  font-weight: 700;
  color: #006fb3;
}

.sizeRange {
  border-radius: 4px;
  display: inline-block;
  width: 120px;
  height: 60px;
  position: relative;
  top: -1em;
  padding: 1em;
  vertical-align: middle;
  line-height: 60px;
}

.info-height {
  color: #707070;
  font-size: 16px;
  font-weight: 400;
}

.size-unit {
  position: relative;
  top: -3em;
  line-height: 30px;
  text-align: center;
}

.product-panel {
  border-top: 3px solid #b4b4b4;
  background-color: #fff;
}

.panel-open {
  border-top: 3px solid #006fb3;
  background-color: #fff;
}

.step-title {
  font-size: 15px;
  font-weight: 700;
  color: #b4b4b4;
}

.step-tile-active {
  font-size: 15px;
  font-weight: 700;
  color: #006fb3;
}

.step-icon-active {
  color: #006fb3;
}

.next-step {
  border-radius: 4px;
  height: 60px;
}

.activeProductTitle {
  color: #b4b4b4;
  font-size: 16px;
  font-weight: 400;
}

.product-tile {
  border: 1px solid #d0d0d0;
}

.product-tile-title {
  font-weight: 400;
  font-size: 19px;
  color: #707070;
}

.horizontalblinds-product-image {
  position: relative;
  right: 10px;
  width: 100%;
  height: 200px;
}

@media screen and (max-width: 1024px){
  .horizontalblinds-product-image {
  position: relative;
  right: 10px;
  width: 100% !important;
  height: 200px;
}
}

.selected {
  border: 2px solid #006fb3;
}

.plooi-selected {
  border: 2px solid #006fb3 !important;
}

.seperator-line {
  border: 1px solid #b4b4b4;
}

/* The container */
.radio-container {
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

}

/* Hide the browser's default radio button */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  bottom: 15px;
  right: 15px;
  height: 35px;
  width: 36px;
  background-color: transparent;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.radio-container:hover input~.checkmark {
  background-color: transparent;
}

/* When the radio button is checked, add a blue background */
.radio-container input:checked~.checkmark {
  background-color: #006fb3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio-container input:checked~.checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.radio-container .checkmark:after {
  top: 8px;
  left: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-image: url('../assets/ui-elements/checkmark.png');
  background-repeat: no-repeat;
}

.gordijnen-product-image {
  width: 50%;
}

.plooi-product-image {
  width: 50%;
}

.sub-product-tile {
  border: 1px solid #eaeaea;
}

.subproduct-tile-title {
  color: #707070;
  font-size: 18px;
  font-weight: 400;
}

.total-title {
  color: #006fb3;
  font-size: 13px;
  font-weight: 700;
}

.price-title {
  color: #006fb3;
  font-size: 13px;
  font-weight: 700;
}


.total-item {
  color: #707070;
  font-size: 13px;
  font-weight: 400;
}

#addToCart {
  border-radius: 4px;
  height: 60px;
  margin: 0 !important;
}

.price-total {
  font-size: 15px;
  color: #006fb3;
  font-weight: 700;
}

.end-total-title {
  font-size: 15px;
  color: #006fb3;
  font-weight: 700;
}

.form-btn {
  border-radius: 4px;
  height: 60px;
  margin: 0 !important;
  width: 180px;
}

.icon-size {
  font-size: 20px;
}

#col-btn {
  padding-right: 0;
  padding-left: 0;
}


@media screen and (max-width: 425px) {
  .size-unit {
    position: relative;
    top: -2.5em;
  }

  .form-btn {
    width: 100%;
  }

  #height-help {
    margin: 0 auto;
    text-align: center;
    justify-content: center;
  }

  .info-height {
    font-size: 13px;
  }

  .activeProductTitle {
    font-size: 14px;
  }

  #addToCart {
    width: 100%;
  }

}

@media screen and (max-width: 320px) {
  .size-unit {
    position: relative;
    top: -3em;
  }

  .activeProductTitle {
    display: none;
  }

}
</style>
